import {callApi} from './helpers'
import {redirect} from 'redux-first-router'

export const goToAtskaites = () => {
    return (dispatch, getState) => {
        dispatch(redirect({
            type: 'loc_atskaites',
            payload: {}
        }))
    }
}

export const saveAtskaite = (atskaite, afterSave) => (dispatch, getState) => {
    return dispatch(callApi({
        viewName: 'atskaite',
        crudMethod: 'save',
        crudParam: atskaite,
        success: afterSave
    }))
}

export const reloadAtskaite = (id) => (dispatch, getState) => {
    return dispatch(callApi({
        viewName: 'atskaite',
        crudMethod: 'get',
        crudParam:  id ,
        success: (atskaite) => {
          return dispatch(callApi({
            viewName: 'atskaite',
            crudMethod: 'save',
            crudParam: atskaite,
            success: (result) => {
              dispatch(loadAtskaites(getState().location.query))
            }
          }))
        }
    }))
}

export const loadAtskaites = (query) => (dispatch) => {
    return dispatch(callApi({
      viewName: 'atskaite',
      crudMethod: 'listPaging',
      crudParam: query
    }))
}

export const deleteAtskaite = (id) => (dispatch, getState) => {
  return dispatch(callApi({
    viewName: 'atskaite',
    crudMethod: 'delete',
    crudParam: id,
    success: (result) => {
      dispatch(loadAtskaites(getState().location.query))
    }
  }))
}
